import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/"
)({
  beforeLoad: () => {
    throw redirect({
      to: "..",
    });
  },
});
